import { merge } from './helpers';
import AnalyticsService from './services/analyticsService';

const defaultConfig = {
  $vue: null,
  id: null,
  router: null,
  baseUrl: null,
  ignoreRoutes: [],
  methods: {},
  ANALYTICS_SERVICE: new AnalyticsService(),
};

let config = { ...defaultConfig };

export function update(params) {
  merge(config, params);
}

export function reset() {
  config = { ...defaultConfig };
}

export default config;
